import { FC, useCallback, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentArticleAsAvailable } from '@article/shared/atoms/current-article';
import { Link } from '@remix-run/react';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ClickPosition } from '~/utils/click-position';
import { useTranslation } from 'react-i18next';
import useReflowClick from '~/utils/use-reflow-click';
import { useActiveToCurrentArticle } from '@article/shared/utils/use-active-to-current-article';
import { $CurrentArticleTranslated } from '@article/shared/atoms/current-article-translated';
import { kepQueryFormat } from 'shared/utils/format/kep-formatter';

import './style.scss';

export const ArticleSarSection: FC = () => {
  const { t } = useTranslation();
  const { relatedQuery = '', articleRegion } = useAtomValue($CurrentArticleAsAvailable);
  const articleTranslated = useAtomValue($CurrentArticleTranslated);
  const activeToCurrentArticle = useActiveToCurrentArticle();

  const kepUrl = useMemo(() => `/discover/${kepQueryFormat(relatedQuery)}?region=${articleRegion}`, [relatedQuery]);

  const sarObservedRef = useViewTracking<HTMLAnchorElement>({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        click_position: ClickPosition.main_sar,
      });
    }, []),
  });

  const handleSarClick = useReflowClick(
    {
      reflowBehavior: () => {
        activeToCurrentArticle(ClickPosition.main_sar);
      },
      clickEvent: () => ({
        current_position: ClickPosition.main_sar,
        page_click_id: kepQueryFormat(relatedQuery) || '',
      }),
    },
    [activeToCurrentArticle],
  );

  if (!relatedQuery || articleTranslated) {
    return null;
  }

  return (
    <section id="article-sar">
      <Link to={kepUrl} onClick={handleSarClick} className="sar-discover" ref={sarObservedRef}>
        <div className="sar-container">
          <div className="search-icon" />
          <div className="search-text">{t('search_sar_query')} ·</div>
          <div className="search-query">{relatedQuery}</div>
          <div className="arrow-icon" />
        </div>
      </Link>
    </section>
  );
};
